import { RootState } from '../index';
import { slice } from './slice';

export const getTimesheetMetaState = (state: RootState) => state.timesheetMeta;

export const { set } = slice.actions;
export const timesheetMetaReducer = slice.reducer;

export * from './actions';
